<template lang="pug">
#card-analise-socioambiental-operacao
    BaseHeader(
        :titulo='$t("mensagens.operacao.cadastrarEditarOperacao.analiseProtocoloSocio.titulo")',
        voltarPara='emit',
        @voltarClicado='fechar()',
        :exibeBotao='false'
    )

    section.card-resumo-analise-socioambiental-operacao
        h2 {{ $t('mensagens.operacao.cadastrarEditarOperacao.analiseProtocoloSocio.resumoTitulo') }}

        .card-resumo-analise-socioambiental-operacao-body
            ol.card-resumo-analise-socioambiental-operacao-list
                li(@click='scrollToSection("protocolo")')
                    span {{ $t('mensagens.operacao.cadastrarEditarOperacao.analiseProtocoloSocio.protocoloSocioTitulo') }}
                    ResumoTag(
                        v-if='resultadoAnaliseGeral.socioambiental',
                        :status='resultadoAnaliseGeral.socioambiental'
                    )
                li(@click='scrollToSection("aptidao")')
                    span {{ $t('mensagens.operacao.cadastrarEditarOperacao.analiseProtocoloSocio.aptidaoTitulo') }}
                    ResumoTag(
                        v-if='resultadoAnaliseGeral.aptidaoFinanciamento',
                        :status='resultadoAnaliseGeral.aptidaoFinanciamento'
                    )
                li(@click='scrollToSection("duplicidade")')
                    span {{ $t('mensagens.operacao.cadastrarEditarOperacao.analiseProtocoloSocio.duplicidadeTitulo') }}
                    ResumoTag(
                        v-if='resultadoAnaliseGeral.duplicidadeCredito',
                        :status='resultadoAnaliseGeral.duplicidadeCredito'
                    )
            .card-resumo-analise-socioambiental-operacao-conclusao(
                :class='operacaoConclusaoStatusPosAnalise'
            )
                i.resumo-conclusao-icon(
                    :class='resumoStatusIcones(operacaoConclusaoStatusPosAnalise)'
                )
                h2 {{ $t(`mensagens.operacao.cadastrarEditarOperacao.analiseProtocoloSocio.conclusaoAnaliseTitulo.${operacaoConclusaoStatusPosAnalise}`) }}
                span {{ $t(`mensagens.operacao.cadastrarEditarOperacao.analiseProtocoloSocio.conclusaoAnaliseDescricao.${operacaoConclusaoStatusPosAnalise}`) }}

    section.card-resumo-analise-protocolo-socioambiental(ref='protocolo')
        .card-resumo-analise-protocolo-socioambiental__header
            h2 {{ $t('mensagens.operacao.cadastrarEditarOperacao.analiseProtocoloSocio.protocoloSocioCardTitulo') }}
            ResumoTag(v-if='statusProtocolo', :status='statusProtocolo')

        .card-resumo-analise-protocolo-socioambiental__body
            div(
                v-for='(diagnosticoProtocolo, index) in diagnosticosProtocolo',
                :key='index',
                @click='abrirModalResultado(diagnosticoProtocolo)'
            )
                .card-resumo-analise-protocolo-socioambiental__body__item(
                    :class='statusClasses(diagnosticoProtocolo.status)'
                )
                    .d-wrap.align-content-stretch
                        .d-flex.align-items-center
                            i.card-resumo-analise-protocolo-socioambiental__body__item__icone(
                                :class='statusIcones(diagnosticoProtocolo.status)'
                            )
                            .font-weight-bold {{ $t(`mensagens.operacao.monitoramento.${diagnosticoProtocolo.codigo}`) }}: {{ diagnosticoProtocolo.nome }}

                        .car-vinculado.font-weight-bold(
                            v-if='diagnosticoProtocolo.carsVinculadosTerritorio'
                        ) {{ $t('mensagens.operacao.car') }}: {{ diagnosticoProtocolo.carsVinculadosTerritorio }}

                    i.el-icon-arrow-right.el-icon--right.card-resumo-analise-protocolo-socioambiental__body__item--acao

    section.card-resumo-analise-aptidao(ref='aptidao')
        .card-resumo-analise-aptidao__header
            h2 {{ $t('mensagens.operacao.cadastrarEditarOperacao.analiseProtocoloSocio.aptidaoCardTitulo') }}
            ResumoTag(v-if='statusAptidao', :status='statusAptidao')

        .card-resumo-analise-aptidao__dispensada(
            v-if='statusAptidao === "NAO_SE_APLICA"'
        )
            i.el-icon-remove
            h3 {{ $t('mensagens.operacao.cadastrarEditarOperacao.analiseProtocoloSocio.aptidaoDispensadaTitulo') }}
            p {{ $t('mensagens.operacao.cadastrarEditarOperacao.analiseProtocoloSocio.aptidaoDispensadaDescricao') }}

        template(v-if='statusAptidao !== "NAO_SE_APLICA"')
            .card-resumo-analise-aptidao__resultado-consolidado.card-resumo-analise-aptidao__resultado-consolidado--sucesso(
                v-if='statusAptidao === "SUCESSO"'
            )
                span.card-resumo-analise-aptidao__resultado-consolidado__label {{ $t('mensagens.operacao.cadastrarEditarOperacao.analiseProtocoloSocio.resultadoConsolidado') }}
                span.card-resumo-analise-aptidao__resultado-consolidado__status {{ $t(`mensagens.operacao.cadastrarEditarOperacao.analiseProtocoloSocio.restricoesTag.${statusAptidao}`) }}
                el-divider.card-resumo-analise-aptidao__resultado-consolidado__divider
                .card-resumo-analise-aptidao__resultado-consolidado__aviso
                    i.el-icon-circle-check
                    span {{ $t('mensagens.operacao.cadastrarEditarOperacao.analiseProtocoloSocio.resultadoConsolidadoSucesso') }}

            .card-resumo-analise-aptidao__resultado-consolidado(
                v-if='statusAptidao === "ALERTA" || statusAptidao === "ATENCAO"'
            )
                span.card-resumo-analise-aptidao__resultado-consolidado__label {{ $t('mensagens.operacao.cadastrarEditarOperacao.analiseProtocoloSocio.resultadoConsolidado') }}
                span.card-resumo-analise-aptidao__resultado-consolidado__status {{ $t(`mensagens.operacao.cadastrarEditarOperacao.analiseProtocoloSocio.restricoesTag.${statusAptidao}`) }}
                el-divider.card-resumo-analise-aptidao__resultado-consolidado__divider
                .card-resumo-analise-aptidao__resultado-consolidado__aviso
                    i.flow.flow-warning-sign
                    span {{ $t('mensagens.operacao.cadastrarEditarOperacao.analiseProtocoloSocio.resultadoConsolidadoAviso') }}

        el-table(v-if='statusAptidao !== "NAO_SE_APLICA"', :data='resultadosAptidao', style='width: 100%')
            el-table-column(label='Gleba', min-width='200')
                template(slot-scope='scope')
                    span {{ scope.row.gleba.nomeTerritorio }} - {{ scope.row.gleba.nome }}
            el-table-column(
                :label='$t("mensagens.operacao.formularioGleba.areaHa")',
                width='100'
            )
                template(slot-scope='scope')
                    span {{ scope.row.gleba.areaHa }} ha
            el-table-column(
                :label='$t("mensagens.operacao.cadastrarEditarOperacao.analiseProtocoloSocio.historicoAgricola")',
                align='center'
            )
                template(slot-scope='scope')
                    ResumoTag(:status='scope.row.historicoAgricola.status')
            el-table-column(
                :label='$t("mensagens.operacao.cadastrarEditarOperacao.analiseProtocoloSocio.pastagem")',
                align='center'
            )
                template(slot-scope='scope')
                    ResumoTag(:status='scope.row.pastagem.status')
            el-table-column(
                :label='$t("mensagens.operacao.cadastrarEditarOperacao.analiseProtocoloSocio.declividade")',
                align='center'
            )
                template(slot-scope='scope')
                    ResumoTag(
                        :status='scope.row.declividade.status',
                        :title='getDeclidadeTooltip(scope.row.declividade)'
                    )
            el-table-column(
                :label='$t("mensagens.operacao.cadastrarEditarOperacao.analiseProtocoloSocio.janelaZarc")',
                align='center'
            )
                template(slot-scope='scope')
                    ResumoTag(:status='scope.row.janelaZarc.status')
            el-table-column(align='right', width='120')
                template(slot-scope='scope')
                    span.card-resumo-analise-aptidao__detalhes-link(
                        @click='abrirModalDetalheAptidao(scope.row)'
                    ) {{ $t('mensagens.operacao.cadastrarEditarOperacao.analiseProtocoloSocio.detalhes') }}
                        i.el-icon-arrow-right

    section.card-resumo-analise-duplicidade(ref='duplicidade')
        .card-resumo-analise-duplicidade__header
            div
                h2 {{ $t('mensagens.operacao.cadastrarEditarOperacao.analiseProtocoloSocio.duplicidadeCardTitulo') }}
                span.card-resumo-analise-duplicidade__subtitle(v-if='statusDuplicidade !== "NAO_SE_APLICA"') {{ $t('mensagens.operacao.cadastrarEditarOperacao.analiseProtocoloSocio.duplicidadeCardSubtitulo') }}
            ResumoTag(v-if='statusDuplicidade', :status='statusDuplicidade')

        .card-resumo-analise-duplicidade__dispensada(
            v-if='statusDuplicidade === "NAO_SE_APLICA"'
        )
            i.el-icon-remove
            h3 {{ $t('mensagens.operacao.cadastrarEditarOperacao.analiseProtocoloSocio.duplicidadeDispensadaTitulo') }}
            p {{ $t('mensagens.operacao.cadastrarEditarOperacao.analiseProtocoloSocio.duplicidadeDispensadaDescricao') }}

        .card-resumo-analise-duplicidade__subsection(v-if='statusDuplicidade !== "NAO_SE_APLICA"')
            span.card-resumo-analise-duplicidade__subsection__titulo {{ $t('mensagens.operacao.cadastrarEditarOperacao.analiseProtocoloSocio.duplicidadeCarteiraTitulo') }}
            span.card-resumo-analise-duplicidade__tag(
                :class='duplicidadeCarteiraTagClass'
            )
                i(:class='duplicidadeCarteiraIconClass')
                | {{ duplicidadeCarteiraTagText }}

        .card-resumo-analise-duplicidade__subsection.card-resumo-analise-duplicidade__subsection--expandida(v-if='statusDuplicidade !== "NAO_SE_APLICA"')
            .card-resumo-analise-duplicidade__subsection__header
                span.card-resumo-analise-duplicidade__subsection__titulo {{ $t('mensagens.operacao.cadastrarEditarOperacao.analiseProtocoloSocio.duplicidadeOutraInstituicaoTitulo') }}
                span.card-resumo-analise-duplicidade__tag(
                    :class='duplicidadeOutraInstituicaoTagClass'
                )
                    i(:class='duplicidadeOutraInstituicaoIconClass')
                    | {{ duplicidadeOutraInstituicaoTagText }}

            .card-resumo-analise-duplicidade__alerta(
                v-if='glebasDuplicadas && glebasDuplicadas.length'
            )
                i.el-icon-info
                div
                    strong {{ $t('mensagens.operacao.cadastrarEditarOperacao.analiseProtocoloSocio.operacoesParalelas') }}
                    p {{ $t('mensagens.operacao.cadastrarEditarOperacao.analiseProtocoloSocio.operacoesParalelasDescricao', { count: glebasDuplicadas.length }) }}

            el-table(
                v-if='glebasDuplicadas && glebasDuplicadas.length',
                :data='glebasDuplicadas',
                style='width: 100%'
            )
                el-table-column(
                    :label='$t("mensagens.operacao.cadastrarEditarOperacao.analiseProtocoloSocio.gleba")',
                    label-class-name='duplicidade-credito-table_label',
                    min-width='150'
                )
                    template(slot-scope='scope')
                        span.duplicidade-credito_text {{ scope.row.glebaOriginal.nome || '-' }}
                el-table-column(
                    :label='$t("mensagens.operacao.cadastrarEditarOperacao.analiseProtocoloSocio.finalidade")',
                    label-class-name='duplicidade-credito-table_label',
                    width='110'
                )
                    template(slot-scope='scope')
                        span.duplicidade-credito_text {{ scope.row.glebaDuplicada.finalidade || '-' }}
                el-table-column(
                    :label='$t("mensagens.operacao.cadastrarEditarOperacao.analiseProtocoloSocio.atividade")',
                    label-class-name='duplicidade-credito-table_label',
                    width='110'
                )
                    template(slot-scope='scope')
                        span.duplicidade-credito_text {{ scope.row.glebaDuplicada.atividade || '-' }}
                el-table-column(
                    :label='$t("mensagens.operacao.cadastrarEditarOperacao.analiseProtocoloSocio.modalidade")',
                    label-class-name='duplicidade-credito-table_label',
                    min-width='140'
                )
                    template(slot-scope='scope')
                        span.duplicidade-credito_text {{ scope.row.glebaDuplicada.modalidade || '-' }}
                el-table-column(
                    :label='$t("mensagens.operacao.cadastrarEditarOperacao.analiseProtocoloSocio.produto")',
                    label-class-name='duplicidade-credito-table_label',
                    min-width='140'
                )
                    template(slot-scope='scope')
                        span.duplicidade-credito_text {{ scope.row.glebaDuplicada.produto || '-' }}
                el-table-column(
                    :label='$t("mensagens.operacao.cadastrarEditarOperacao.analiseProtocoloSocio.areaFinanciamento")',
                    label-class-name='duplicidade-credito-table_label',
                    width='130'
                )
                    template(slot-scope='scope')
                        span {{ scope.row.glebaDuplicada.areaFinanciamentoHa ? scope.row.glebaDuplicada.areaFinanciamentoHa + ' ha' : '-' }}
                el-table-column(
                    :label='$t("mensagens.operacao.cadastrarEditarOperacao.analiseProtocoloSocio.estado")',
                    label-class-name='duplicidade-credito-table_label',
                    width='80'
                )
                    template(slot-scope='scope')
                        span {{ scope.row.glebaDuplicada.uf || '-' }}
                el-table-column(
                    :label='$t("mensagens.operacao.cadastrarEditarOperacao.analiseProtocoloSocio.dataEmissao")',
                    label-class-name='duplicidade-credito-table_label',
                    width='130'
                )
                    template(slot-scope='scope')
                        span {{ scope.row.glebaDuplicada.dataEmissao || '-' }}
                el-table-column(
                    :label='$t("mensagens.operacao.cadastrarEditarOperacao.analiseProtocoloSocio.inicioPlantio")',
                    label-class-name='duplicidade-credito-table_label',
                    width='120'
                )
                    template(slot-scope='scope')
                        span {{ scope.row.glebaDuplicada.dataInicioPlantio || '-' }}
                el-table-column(
                    :label='$t("mensagens.operacao.cadastrarEditarOperacao.analiseProtocoloSocio.inicioColheita")',
                    label-class-name='duplicidade-credito-table_label',
                    width='140'
                )
                    template(slot-scope='scope')
                        span {{ scope.row.glebaDuplicada.dataInicioColheita || '-' }}
                el-table-column(align='right', width='90')
                    template(slot-scope='scope')
                        span.card-resumo-analise-duplicidade__detalhes-link(
                            @click='abrirModalDetalheDuplicidade(scope.row)'
                        ) {{ $t('mensagens.operacao.cadastrarEditarOperacao.analiseProtocoloSocio.detalhes') }}
                            i.el-icon-arrow-right

    section.card-analise-socioambiental-operacao__aprovar-recusar(
        v-if='habilitarAnalise'
    )
        h2 {{ $t('mensagens.comuns.situacao') }}

        el-form(label-position='top', size='small')
            el-form-item.mt-2
                el-radio-group(v-model='escolhaAprovarReprovar')
                    el-radio.mr-4(
                        :label='$t("mensagens.operacao.acoes.aprovar")'
                    )
                    el-radio(:label='$t("mensagens.operacao.acoes.reprovar")')

            el-form-item.mt-1(v-if='opcaoReprovarAtiva')
                div(slot='label', style='display: grid')
                    span.campo_obrigatorio {{ $t('mensagens.operacao.motivo') }}

                    el-select(
                        v-model='motivosReprovacaoSelecao',
                        multiple,
                        clearable
                    )
                        el-option(
                            v-for='{ nome, id } in motivosReprovacao',
                            :key='nome',
                            :label='nome',
                            :value='id'
                        )

            .card-operacao-com-restricao(
                v-if='possuiRestricaoAprovacao'
            )
                .card-operacao-com-restricao__header
                    span.card-operacao-com-restricao__indicador
                    h3 {{ $t('mensagens.operacao.cadastrarEditarOperacao.analiseProtocoloSocio.operacaoComRestricaoTitulo') }}
                p.card-operacao-com-restricao__descricao {{ $t('mensagens.operacao.cadastrarEditarOperacao.analiseProtocoloSocio.operacaoComRestricaoDescricao') }}
                .card-operacao-com-restricao__restricoes
                    strong {{ $t('mensagens.operacao.cadastrarEditarOperacao.analiseProtocoloSocio.restricoesLabel') }}
                    ul
                        li(v-for='(restricao, index) in listaRestricoes', :key='index') {{ restricao }}

            el-form-item
                div(slot='label')
                    span(v-if='opcaoReprovarAtiva || possuiRestricaoAprovacao', style='color: red') *
                    span(v-if='possuiRestricaoAprovacao') {{ $t('mensagens.operacao.cadastrarEditarOperacao.analiseProtocoloSocio.justificativaAprovacaoComRestricao') }}
                    span(v-else) {{ $t('mensagens.operacao.justificativa') }}

                    el-tooltip(
                        v-if='opcaoReprovarAtiva',
                        :content='$t("mensagens.operacao.cadastrarEditarOperacao.analiseProtocoloSocio.textoJustificativa")',
                        placement='right',
                        effect='light'
                    )
                        i.mdi.mdi-information-outline.ml-2

                el-input(
                    v-model='justificativaAprovarReprovar',
                    :maxlength='255',
                    :placeholder='possuiRestricaoAprovacao ? $t("mensagens.operacao.cadastrarEditarOperacao.analiseProtocoloSocio.placeholderJustificativaRestricao") : $t("mensagens.operacao.justificativa")',
                    type='textarea',
                    resize='none',
                    :rows='2'
                )

    section.card-analise-socioambiental-operacao__acao(v-if='habilitarAnalise')
        BaseButton.mr-2(size='small', @click='fechar()')
            | {{ $t('mensagens.comuns.voltar') }}

        BaseButton(
            @click='aprovarRecusarOperacao()',
            :disabled='permitirFinalizarAnalise()',
            type='primary',
            size='small'
        )
            | {{ $t('mensagens.operacao.acoes.finalizarAnalise') }}

    section.card-analise-socioambiental-operacao__acao(v-else)
        BaseButton(size='small', @click='fechar()')
            | {{ $t('mensagens.comuns.voltar') }}

        BaseButton(
            v-if='habilitarBotaoCadastrar',
            @click='cadastrarOperacao()',
            type='primary',
            size='small'
        )
            | {{ editandoOperacao ? $t('mensagens.comuns.salvar') : $t('mensagens.operacao.acoes.cadastrarOperacao') }}

    ModalResultadoDiagnostico(ref='modalResultadoDiagnostico')

    ModalDetalheAptidao(ref='modalDetalheAptidao')

    ModalDetalheDuplicidade(ref='modalDetalheDuplicidade')

    ModalConfirmarAprovacao(
        :mostrar='mostrarModalConfirmarAprovacao',
        @confirmar='confirmarAprovacao',
        @fechar='mostrarModalConfirmarAprovacao = false'
    )
</template>

<script>
import BaseHeader from '@/components/BaseHeader.vue';
import ModalResultadoDiagnostico from '@/components/operacao/gestao/ModalResultadoDiagnostico.vue';
import OperacaoService from '@/services/OperacaoService';
import BaseButton from '@/components/vegaComponents/BaseButton.vue';
import { calcularBuffer } from '@/utils/calcularBuffer.js';
import ModalConfirmarAprovacao from '@/components/operacao/gestao/ModalConfirmarAprovacao.vue';
import ModalDetalheAptidao from '@/components/operacao/gestao/ModalDetalheAptidao.vue';
import ModalDetalheDuplicidade from '@/components/operacao/gestao/ModalDetalheDuplicidade.vue';
import ResumoTag from '@/components/operacao/gestao/ResumoTag.vue';
import formatters from '@/utils/formatters';

export default {
    name: 'CardAnaliseSocioambientalOperacao',
    components: {
        BaseHeader,
        ModalResultadoDiagnostico,
        BaseButton,
        ModalConfirmarAprovacao,
        ModalDetalheAptidao,
        ModalDetalheDuplicidade,
        ResumoTag
    },
    emits: [
        'aprovarOperacao',
        'reprovarOperacao',
        'fechar',
        'cadastrarOperacao'
    ],

    props: {
        dadosDiagnostico: {
            type: Object,
            required: true
        },
        editandoOperacao: {
            type: Boolean,
            required: false,
            default: false
        },
        habilitarBotaoCadastrar: {
            type: Boolean,
            required: false,
            default: true
        },
        habilitarAnalise: {
            type: Boolean,
            required: false,
            default: false
        },
        statusAnalise: {
            type: String,
            required: false,
            default: ''
        }
    },

    computed: {
        opcaoReprovarAtiva() {
            return (
                this.escolhaAprovarReprovar ===
                this.$t('mensagens.operacao.acoes.reprovar')
            );
        },
        categoriasAptidaoComAlerta() {
            const categorias = ['historicoAgricola', 'pastagem', 'declividade', 'janelaZarc'];
            const categoriasAlerta = new Set();

            for (const resultado of this.resultadosAptidao) {
                for (const categoria of categorias) {
                    if (resultado[categoria] && resultado[categoria].status === 'ALERTA') {
                        categoriasAlerta.add(categoria);
                    }
                }
            }

            return Array.from(categoriasAlerta);
        },
        listaRestricoes() {
            const restricoes = [];
            const categoriasAlerta = this.categoriasAptidaoComAlerta;

            const diagnosticosRestricao = [];
            this.diagnosticosProtocolo.forEach(dp => {
                if (dp.status === 'ALERTA') {
                    diagnosticosRestricao.push(this.$t(`mensagens.operacao.monitoramento.${dp.codigo}`));
                }
            });
            if (diagnosticosRestricao.length > 0) {
                restricoes.push(`${this.$t('mensagens.operacao.cadastrarEditarOperacao.analiseProtocoloSocio.protocoloSocioCardTitulo')} (${diagnosticosRestricao.join(', ')})`);
            }

            if (categoriasAlerta.length) {
                const nomes = categoriasAlerta.map(cat =>
                    this.$t(`mensagens.operacao.cadastrarEditarOperacao.analiseProtocoloSocio.${cat}`)
                );
                restricoes.push(
                    `${this.$t('mensagens.operacao.cadastrarEditarOperacao.analiseProtocoloSocio.aptidaoTitulo')} (${nomes.join(', ')})`
                );
            }

            if (this.resultadoAnaliseGeral.duplicidadeCredito === 'ALERTA') {
                restricoes.push(
                    this.$t('mensagens.operacao.cadastrarEditarOperacao.analiseProtocoloSocio.duplicidadeCardTitulo')
                );
            }

            return restricoes;
        },
        possuiRestricaoOperacao() {
            return this.listaRestricoes.length > 0;
        },
        possuiRestricaoAprovacao() {
            return !this.opcaoReprovarAtiva && this.possuiRestricaoOperacao;
        },
        operacaoConclusaoStatusPosAnalise() {
            if (
                this.resultadoAnaliseGeral.socioambiental === 'ALERTA' ||
                this.resultadoAnaliseGeral.aptidaoFinanciamento === 'ALERTA' ||
                this.resultadoAnaliseGeral.duplicidadeCredito === 'ALERTA'
            ) {
                return 'ALERTA';
            } else if (
                this.resultadoAnaliseGeral.socioambiental === 'ATENCAO' ||
                this.resultadoAnaliseGeral.aptidaoFinanciamento === 'ATENCAO' ||
                this.resultadoAnaliseGeral.duplicidadeCredito === 'ATENCAO'
            ) {
                return 'ATENCAO';
            }
            return 'SUCESSO';
        },
        duplicidadeCarteiraTagClass() {
            return this.getDuplicidadeTagClass(this.statusDuplicidadeCarteira);
        },
        duplicidadeCarteiraIconClass() {
            return this.getDuplicidadeIconClass(this.statusDuplicidadeCarteira);
        },
        duplicidadeCarteiraTagText() {
            return this.getDuplicidadeTagText(this.statusDuplicidadeCarteira);
        },
        duplicidadeOutraInstituicaoTagClass() {
            return this.getDuplicidadeTagClass(
                this.statusDuplicidadeOutraInstituicao
            );
        },
        duplicidadeOutraInstituicaoIconClass() {
            return this.getDuplicidadeIconClass(
                this.statusDuplicidadeOutraInstituicao
            );
        },
        duplicidadeOutraInstituicaoTagText() {
            const texto = this.getDuplicidadeTagText(
                this.statusDuplicidadeOutraInstituicao
            );
            if (this.statusDuplicidadeOutraInstituicao === 'SUCESSO') {
                return texto;
            }
            const count = this.glebasDuplicadas
                ? this.glebasDuplicadas.length
                : 0;
            return `${texto} (${count})`;
        }
    },

    data() {
        return {
            statusProtocolo: null,
            diagnosticosProtocolo: [],
            statusAptidao: null,
            resultadosAptidao: [],
            escolhaAprovarReprovar: this.$t('mensagens.operacao.acoes.aprovar'),
            justificativaAprovarReprovar: null,
            mostrarDialogCamadas: false,
            mostrarCardAprovarReprovar: false,
            motivosReprovacao: [],
            motivosReprovacaoSelecao: [],
            territorios: [],
            diagnosticoPessoa: false,
            mostrarModalConfirmarAprovacao: false,
            habilitarFinalizarAnalise: false,
            status: {
                ALERTA: {
                    classeIcone: 'alerta flow flow-warning-sign'
                },
                SUCESSO: {
                    classeIcone: 'sucesso el-icon-circle-check'
                },
                ATENCAO: {
                    classeIcone: 'atencao flow flow-warning-sign'
                }
            },
            resumo_status: {
                ALERTA: {
                    classeIcone: 'el-icon-circle-close'
                },
                SUCESSO: {
                    classeIcone: 'el-icon-circle-check'
                },
                ATENCAO: {
                    classeIcone: 'el-icon-warning'
                },
                NAO_SE_APLICA: {
                    classeIcone: 'el-icon-remove'
                },
                NAO_ANALISADO: {
                    classeIcone: 'el-icon-remove'
                }
            },
            resultadoAnaliseGeral: {
                socioambiental: null,
                aptidaoFinanciamento: null,
                duplicidadeCredito: null
            },
            statusDuplicidade: null,
            statusDuplicidadeCarteira: null,
            statusDuplicidadeOutraInstituicao: null,
            glebasDuplicadas: []
        };
    },

    async mounted() {
        this.realizarDiagnosticoListagem();
        await Promise.all([
            this.buscarAptidaoFinanciamento(),
            this.buscarDuplicidade(),
            this.buscarMotivosReprovacao()
        ]);
    },

    methods: {
        scrollToSection(ref) {
            const el = this.$refs[ref];
            if (el) {
                el.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        },

        permitirFinalizarAnalise() {
            if (!this.habilitarFinalizarAnalise) {
                return true;
            } else {
                if (!this.opcaoReprovarAtiva) {
                    return (this.possuiRestricaoAprovacao) && (!this.justificativaAprovarReprovar || this.justificativaAprovarReprovar.length === 0);
                } else {
                    return (!this.justificativaAprovarReprovar || this.justificativaAprovarReprovar.length === 0 || !this.motivosReprovacaoSelecao || this.motivosReprovacaoSelecao.length === 0);
                }
            }
        },

        getDeclidadeTooltip(declividade) {
            if (
                declividade.status === 'ALERTA' &&
                declividade.percentual != null
            ) {
                return this.$t(
                    'mensagens.operacao.cadastrarEditarOperacao.analiseProtocoloSocio.declidadeTooltip',
                    { percentual: declividade.percentual }
                );
            }
            return null;
        },

        getDuplicidadeTagClass(status) {
            if (status === 'SUCESSO') { return 'card-resumo-analise-duplicidade__tag--sucesso'; }
            if (status === 'ATENCAO') { return 'card-resumo-analise-duplicidade__tag--atencao'; }
            return 'card-resumo-analise-duplicidade__tag--alerta';
        },
        getDuplicidadeIconClass(status) {
            return status === 'SUCESSO'
                ? 'el-icon-circle-check'
                : 'el-icon-warning';
        },
        getDuplicidadeTagText(status) {
            if (status === 'SUCESSO') {
                return this.$t(
                    'mensagens.operacao.cadastrarEditarOperacao.analiseProtocoloSocio.nenhumaDuplicidade'
                );
            }
            return this.$t(
                'mensagens.operacao.cadastrarEditarOperacao.analiseProtocoloSocio.duplicidadeDetectada'
            );
        },

        statusClasses(status) {
            return this.status[status]
                ? this.status[status].classeCollapse
                : '';
        },

        statusIcones(status) {
            return this.status[status] ? this.status[status].classeIcone : '';
        },

        resumoStatusIcones(status) {
            return this.resumo_status[status]
                ? this.resumo_status[status].classeIcone
                : '';
        },

        async aprovarRecusarOperacao() {
            const payload = {
                justificativa: this.justificativaAprovarReprovar,
                motivos: this.motivosReprovacaoSelecao
            };

            if (
                this.escolhaAprovarReprovar ===
                this.$t('mensagens.operacao.acoes.reprovar')
            ) {
                if (
                    !this.justificativaAprovarReprovar ||
                    this.justificativaAprovarReprovar.length === 0
                ) {
                    this.$notify.warning({
                        message: this.$t(
                            'mensagens.operacao.notificacao.preenchaJustificativa'
                        )
                    });
                    return;
                }

                if (this.motivosReprovacaoSelecao.length === 0) {
                    this.$notify.warning({
                        message: this.$t(
                            'mensagens.operacao.notificacao.motivoReprovacao'
                        )
                    });
                    return;
                }

                this.$emit('reprovarOperacao', payload);
            } else {
                if (this.contemAlertaOuAtencao() && (!this.justificativaAprovarReprovar || this.justificativaAprovarReprovar.length === 0)) {
                    this.$notify.warning({
                        message: this.$t(
                            'mensagens.operacao.notificacao.preenchaJustificativa'
                        )
                    });
                } else if (this.contemAlertaOuAtencao()) {
                    this.mostrarModalConfirmarAprovacao = true;
                } else {
                    this.$emit('aprovarOperacao', payload);
                }
            }
        },

        confirmarAprovacao() {
            const payload = {
                justificativa: this.justificativaAprovarReprovar,
                motivos: this.motivosReprovacaoSelecao
            };
            if (this.editandoOperacao) {
                this.$emit('cadastrarOperacao');
            } else {
                this.$emit('aprovarOperacao', payload);
            }
        },

        contemAlertaOuAtencao() {
            return this.diagnosticosProtocolo.some(
                item => item.status === 'ALERTA' || item.status === 'ATENCAO'
            );
        },

        async buscarMotivosReprovacao() {
            try {
                const { data } =
                    await OperacaoService.buscarMotivosReprovacao();
                this.motivosReprovacao = data.itens;
            } catch {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.operacao.notificacao.erroMotivoReprovacao'
                    )
                });
            }
        },

        cadastrarOperacao() {
            if (this.editandoOperacao) {
                if (
                    this.contemAlertaOuAtencao() &&
                    this.statusAnalise &&
                    this.statusAnalise === 'APROVADO'
                ) {
                    this.mostrarModalConfirmarAprovacao = true;
                } else {
                    this.$emit('cadastrarOperacao');
                }
            } else {
                this.$emit('cadastrarOperacao');
            }
        },

        async abrirModalDetalheAptidao(row) {
            try {
                const idCategoria = this.dadosDiagnostico.idCategoria;

                const territorios = this.dadosDiagnostico.territorios || [];
                let geometria = row.gleba.geometria;
                let idTerritorio = row.gleba.idTerritorio;

                if (!(idTerritorio && geometria)) {
                    for (const territorio of territorios) {
                        if (territorio.nomeTerritorio === row.gleba.nomeTerritorio) {
                            idTerritorio = territorio.idTerritorio;
                            if (!geometria) {
                                for (const gleba of territorio.glebas || []) {
                                    if (gleba.nome === row.gleba.nome) {
                                        geometria = gleba.geometria;
                                        break;
                                    }
                                }
                            }
                            if (geometria) break;
                        }
                    }
                }

                const atividades = this.dadosDiagnostico.atividades || [];
                let tipoAtividade = 'AGRICOLA';
                if (atividades.length && atividades[0].tipo && atividades[0].tipo.toLowerCase().includes('pecu')) {
                    tipoAtividade = 'PECUARIA';
                }

                const culturas = atividades.map(atividade => ({
                    nome: atividade.nomeProduto || null,
                    dataInicioPlantio: formatters.localDateToISO(atividade.inicioPlantio) || formatters.formatDateToISO(atividade.inicioPlantio),
                    dataFimPlantio: formatters.localDateToISO(atividade.fimPlantio) || formatters.formatDateToISO(atividade.fimPlantio)
                }));

                const payload = {
                    idCategoria,
                    tipoAtividade,
                    gleba: {
                        nome: row.gleba.nome,
                        idTipo: row.gleba.idTipo,
                        areaHa: this.converterAreaParaNumero(row.gleba.areaHa),
                        geometria,
                        idTerritorio,
                        nomeTerritorio: row.gleba.nomeTerritorio
                    },
                    culturas
                };

                const { data } = await OperacaoService.detalheAnaliseAptidao(payload);
                this.$refs.modalDetalheAptidao.abrirModal(data, culturas);
            } catch {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.operacao.notificacao.erroProtocoloSocio'
                    )
                });
            }
        },

        abrirModalDetalheDuplicidade(row) {
            const territorios = this.dadosDiagnostico.territorios || [];
            let nomeTerritorio = '';
            let geometria = null;
            let geometriaTerritorio = null;
            let areaHa = null;

            for (const territorio of territorios) {
                for (const gleba of territorio.glebas || []) {
                    if (gleba.nome === row.glebaOriginal.nome) {
                        nomeTerritorio = territorio.nomeTerritorio;
                        geometria = gleba.geometria;
                        geometriaTerritorio = territorio.geometria;
                        areaHa = gleba.areaHa;
                        break;
                    }
                }
                if (geometria) break;
            }

            this.$refs.modalDetalheDuplicidade.abrirModal({
                nomeTerritorio,
                status: this.statusDuplicidadeOutraInstituicao,
                glebaOriginal: row.glebaOriginal,
                glebaDuplicada: row.glebaDuplicada,
                areaHa,
                geometria,
                geometriaTerritorio
            });
        },

        abrirModalResultado(diagnosticoProtocolo) {
            switch (diagnosticoProtocolo.codigo) {
                case 'TERRITORIO':
                    OperacaoService.preAnaliseTerritorio({
                        protocolo: diagnosticoProtocolo.protocolo,
                        idTerritorio: diagnosticoProtocolo.identificador
                    })
                        .then(({ data }) => {
                            data.grupo.map(item => {
                                if (
                                    item.codigo ===
                                        'PROXIMIDADE_TERRITORIO_ANALISADO' ||
                                    item.codigo === 'PROXIMIDADE_CAR_ANALISADO'
                                ) {
                                    let geometria;
                                    if (
                                        item.codigo ===
                                        'PROXIMIDADE_TERRITORIO_ANALISADO'
                                    ) {
                                        geometria = data.territorioGeometria;
                                    } else {
                                        geometria =
                                            item.informacoesGerais?.geometria;
                                    }

                                    item.diagnostico.forEach(diagnostico => {
                                        diagnostico.geometriaProximidade =
                                            calcularBuffer(
                                                geometria,
                                                diagnostico.bufferMetros
                                            );
                                    });
                                }

                                if (
                                    item.codigo === 'CAR_ANALISADO' ||
                                    item.codigo === 'PROXIMIDADE_CAR_ANALISADO'
                                ) {
                                    item.geometriaDoCar =
                                        item.informacoesGerais?.geometria;
                                }
                            });
                            this.$refs.modalResultadoDiagnostico.abrirModal(
                                data
                            );
                        })
                        .catch(() => {
                            this.$notify.error({
                                message: this.$t(
                                    'mensagens.operacao.notificacao.erroProtocoloSocio'
                                )
                            });
                        });
                    break;

                case 'GLEBA':
                    OperacaoService.preAnaliseGleba({
                        protocolo: diagnosticoProtocolo.protocolo,
                        idTerritorio: diagnosticoProtocolo.idTerritorio,
                        nomeGleba: diagnosticoProtocolo.nome,
                        glebaGeometria: diagnosticoProtocolo.glebaGeometria,
                        utilizouAreaTotalTerritorio:
                            diagnosticoProtocolo.utilizouAreaTotalTerritorio
                    })
                        .then(({ data }) => {
                            data.grupo.map(item => {
                                if (
                                    item.codigo ===
                                    'PROXIMIDADE_GLEBA_ANALISADA'
                                ) {
                                    item.diagnostico.forEach(diagnostico => {
                                        diagnostico.geometriaProximidade =
                                            calcularBuffer(
                                                data.glebaGeometria,
                                                diagnostico.bufferMetros
                                            );
                                    });
                                }
                            });
                            this.$refs.modalResultadoDiagnostico.abrirModal(
                                data
                            );
                        })
                        .catch(() => {
                            this.$notify.error({
                                message: this.$t(
                                    'mensagens.operacao.notificacao.erroProtocoloSocio'
                                )
                            });
                        });
                    break;

                case 'PESSOA':
                    OperacaoService.preAnalisePessoa({
                        idCategoria: this.dadosDiagnostico.idCategoria,
                        idsTerritorios: this.dadosDiagnostico.territorios.map(
                            p => p.idTerritorio
                        ),
                        protocolo: diagnosticoProtocolo.protocolo,
                        nomeRazaoSocial: diagnosticoProtocolo.nome,
                        cpfCnpj: diagnosticoProtocolo.identificador
                    })
                        .then(({ data }) => {
                            this.$refs.modalResultadoDiagnostico.abrirModal(
                                data
                            );
                        })
                        .catch(() => {
                            this.$notify.error({
                                message: this.$t(
                                    'mensagens.operacao.notificacao.erroProtocoloSocio'
                                )
                            });
                        });
                    break;
            }
        },

        async buscarAptidaoFinanciamento() {
            try {
                const payload = this.montarPayloadAptidao();
                const { data } =
                    await OperacaoService.preAnaliseAptidaoFinanciamento(
                        payload
                    );
                this.statusAptidao = data.status;
                this.resultadosAptidao = data.resultados;
                this.resultadoAnaliseGeral.aptidaoFinanciamento = data.status;
            } catch {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.operacao.notificacao.erroProtocoloSocio'
                    )
                });
            }
        },

        converterAreaParaNumero(areaString) {
            if (typeof areaString === 'number') return areaString;
            if (!areaString) return null;
            return parseFloat(
                String(areaString).replace(/\./g, '').replace(',', '.')
            );
        },

        extrairGlebas() {
            const territorios = this.dadosDiagnostico.territorios || [];
            const glebas = [];
            territorios.forEach(territorio => {
                (territorio.glebas || []).forEach(gleba => {
                    glebas.push({
                        nome: gleba.nome,
                        idTipo: gleba.idTipo,
                        geometria: gleba.geometria,
                        areaHa: this.converterAreaParaNumero(gleba.areaHa),
                        idTerritorio: territorio.idTerritorio,
                        nomeTerritorio: territorio.nomeTerritorio
                    });
                });
            });
            return glebas;
        },

        extrairAtividades() {
            const atividades = this.dadosDiagnostico.atividades || [];

            const tipoAtividadeRaw = atividades.length
                ? atividades[0].tipo
                : '';
            let tipoAtividade = 'AGRICOLA';
            if (
                tipoAtividadeRaw &&
                tipoAtividadeRaw.toLowerCase().includes('pecu')
            ) {
                tipoAtividade = 'PECUARIA';
            }

            const culturas = atividades.map(atividade => ({
                id: atividade.idProduto || null,
                nome: atividade.nomeProduto || null,
                dataInicioPlantio: formatters.localDateToISO(atividade.inicioPlantio) || formatters.formatDateToISO(atividade.inicioPlantio),
                dataFimPlantio: formatters.localDateToISO(atividade.fimPlantio) || formatters.formatDateToISO(atividade.fimPlantio),
                dataInicioColheita: formatters.localDateToISO(atividade.inicioColheita) || formatters.formatDateToISO(atividade.inicioColheita),
                dataFimColheita: formatters.localDateToISO(atividade.fimColheita) || formatters.formatDateToISO(atividade.fimColheita)
            }));

            return { tipoAtividade, culturas };
        },

        montarPayloadAptidao() {
            const idCategoria = this.dadosDiagnostico.idCategoria;

            const atividade = this.extrairAtividades();

            const glebas = this.extrairGlebas();

            return {
                idCategoria,
                tipoAtividade: atividade.tipoAtividade,
                glebas,
                culturas: atividade.culturas
            };
        },

        montarPayloadDuplicidade() {
            const idCategoria = this.dadosDiagnostico.idCategoria;

            const atividade = this.extrairAtividades();

            const glebas = this.extrairGlebas();

            return {
                idOperacao: this.dadosDiagnostico.idOperacao,
                idCategoria,
                tipoAtividade: atividade.tipoAtividade,
                glebas,
                culturas: atividade.culturas
            };
        },

        async buscarDuplicidade() {
            try {
                const payload = this.montarPayloadDuplicidade();
                const { data } = await OperacaoService.preAnaliseDuplicidade(
                    payload
                );
                this.statusDuplicidade = data.status;
                this.statusDuplicidadeCarteira =
                    data.duplicidadeCarteira.status;
                this.statusDuplicidadeOutraInstituicao =
                    data.duplicidadeOutraInstituicao.status;
                this.glebasDuplicadas =
                    data.duplicidadeOutraInstituicao.glebasDuplicadas || [];
                this.resultadoAnaliseGeral.duplicidadeCredito = data.status;
            } catch {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.operacao.notificacao.erroProtocoloSocio'
                    )
                });
            }
        },

        async realizarDiagnosticoListagem() {
            this.dadosDiagnostico.territorios.forEach(element => {
                if (element.visualizarOperacao) {
                    this.territorios.push({
                        id: element.idTerritorio,
                        geometria: element.geometria
                    });
                    this.diagnosticoPessoa = true;
                }
            });

            await OperacaoService.preAnaliseResumo(this.dadosDiagnostico)
                .then(({ data }) => {
                    if (Array.isArray(data)) {
                        this.diagnosticosProtocolo = data;
                    } else {
                        this.diagnosticosProtocolo = data.resultados;
                        this.statusProtocolo = data.status;
                        this.resultadoAnaliseGeral.socioambiental = data.status;
                    }
                    this.habilitarFinalizarAnalise = true;
                })
                .catch(() => {
                    this.$notify.error({
                        message: this.$t(
                            'mensagens.operacao.notificacao.erroProtocoloSocio'
                        )
                    });
                });
        },

        fechar() {
            this.$emit('fechar');
        }
    }
};
</script>

<style lang="scss">
#card-analise-socioambiental-operacao {
    .card-resumo-analise-socioambiental-operacao {
        background-color: var(--white);
        cursor: pointer;
        display: flex;
        flex-direction: column;
        border-radius: $default-border-radius;
        margin: 20px;
        padding: 20px;
        h2 {
            font-weight: bold;
        }

        .card-resumo-analise-socioambiental-operacao-body {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            gap: 24px;

            .card-resumo-analise-socioambiental-operacao-list {
                padding: 0px;
                gap: 10px;
                width: 50%;

                li {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    margin: 15px 0;
                    padding: 10px;
                    background-color: rgba(240, 240, 240, 0.5);
                    border-radius: $default-border-radius;
                    cursor: pointer;
                    transition: background-color 0.2s;

                    &:hover {
                        background-color: rgba(230, 230, 230, 0.8);
                    }
                }
            }

            .card-resumo-analise-socioambiental-operacao-conclusao {
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                width: 50%;
                gap: 10px;
                border-radius: $default-border-radius;

                .resumo-conclusao-icon {
                    font-size: 32px;
                    border-radius: 50%;
                    padding: 10px;
                }

                h2,
                span {
                    color: #3b3b3b;
                }
            }

            .card-resumo-analise-socioambiental-operacao-conclusao.ALERTA {
                background-color: #fff1f0;
                color: #df675b;
                border: 2px solid #fed7d6;
                .resumo-conclusao-icon {
                    background-color: #ffe2e2;
                }
            }
            .card-resumo-analise-socioambiental-operacao-conclusao.SUCESSO {
                background-color: #ecfcf4;
                color: #3d8c73;
                border: 2px solid #acf5d3;
                .resumo-conclusao-icon {
                    background-color: #d0fbe4;
                }
            }
            .card-resumo-analise-socioambiental-operacao-conclusao.ATENCAO {
                background-color: #f6efca;
                color: #f1d11e;
                border: 2px solid #f2dc5e;
                .resumo-conclusao-icon {
                    background-color: #f8e992;
                }
            }
        }
    }

    .card-resumo-analise-protocolo-socioambiental {
        background-color: var(--white);
        display: flex;
        flex-direction: column;
        border-radius: $default-border-radius;
        margin: 20px;
        padding: 20px;

        .card-resumo-analise-protocolo-socioambiental__header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 15px;

            h2 {
                font-weight: bold;
            }
        }

        .card-resumo-analise-protocolo-socioambiental__body {
            gap: 2px;
            display: flex;
            flex-direction: column;

            .card-resumo-analise-protocolo-socioambiental__body__item {
                height: 75px;
                background-color: rgba(240, 240, 240, 0.5);
                cursor: pointer;
                display: flex;
                align-items: center;
                justify-content: space-between;
                border-radius: $default-border-radius;
                transition: 0.3s ease-in-out;

                .card-resumo-analise-protocolo-socioambiental__body__item__icone {
                    font-size: 24px;
                    margin: 0 15px;
                }

                .card-resumo-analise-protocolo-socioambiental__body__item--acao {
                    height: 100%;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    font-size: 18px;
                    margin-right: 20px;
                }

                .alerta {
                    color: #df675b;
                }

                .sucesso {
                    color: var(--secondary-two);
                }

                .atencao {
                    color: #d7bc25;
                }
            }

            .card-resumo-analise-protocolo-socioambiental__body__item:hover {
                opacity: 0.7;
            }
        }

        .card-resumo-analise-protocolo-socioambiental__hint {
            display: flex;
            align-items: center;
            gap: 8px;
            margin-top: 15px;
            font-size: 13px;
            color: #8a8a8a;

            i {
                font-size: 16px;
            }
        }
    }

    .card-resumo-analise-aptidao {
        background-color: var(--white);
        display: flex;
        flex-direction: column;
        border-radius: $default-border-radius;
        margin: 20px;
        padding: 20px;

        .card-resumo-analise-aptidao__header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 15px;

            h2 {
                font-weight: bold;
            }
        }

        .card-resumo-analise-aptidao__resultado-consolidado {
            display: flex;
            flex-direction: column;
            background-color: #fff1f0;
            border-radius: $default-border-radius;
            padding: 15px 20px;
            margin-bottom: 15px;

            .card-resumo-analise-aptidao__resultado-consolidado__label {
                font-size: 12px;
                color: #8b0000;
                font-weight: 600;
            }

            .card-resumo-analise-aptidao__resultado-consolidado__status {
                font-size: 18px;
                font-weight: bold;
                color: #8b0000;
            }

            .card-resumo-analise-aptidao__resultado-consolidado__divider.el-divider {
                margin: 12px 0;
                background-color: transparent;
                border-top: 1px solid #fed7d6;
            }

            .card-resumo-analise-aptidao__resultado-consolidado__aviso {
                display: flex;
                align-items: center;
                gap: 8px;
                margin-top: 10px;
                font-size: 13px;
                color: #5e5e5e;

                i {
                    color: #df675b;
                    font-size: 16px;
                }
            }

            &--sucesso {
                background-color: #ecfcf4;

                .card-resumo-analise-aptidao__resultado-consolidado__label {
                    color: #3d8c73;
                }

                .card-resumo-analise-aptidao__resultado-consolidado__status {
                    color: #3d8c73;
                }

                .card-resumo-analise-aptidao__resultado-consolidado__divider.el-divider {
                    border-top: 1px solid #acf5d3;
                }

                .card-resumo-analise-aptidao__resultado-consolidado__aviso {
                    color: #3d8c73;

                    i {
                        color: #3d8c73;
                    }
                }
            }
        }

        .card-resumo-analise-aptidao__dispensada {
            display: flex;
            flex-direction: column;
            align-items: center;
            text-align: center;
            padding: 40px 20px;

            > i {
                font-size: 32px;
                color: #c0c4cc;
                margin-bottom: 12px;
            }

            h3 {
                font-weight: bold;
                font-size: 14px;
                margin-bottom: 8px;
            }

            p {
                font-size: 13px;
                color: #8a8a8a;
                max-width: 600px;
                margin: 0;
            }
        }

        .card-resumo-analise-aptidao__detalhes-link {
            color: var(--primary);
            cursor: pointer;
            font-size: 13px;

            i {
                margin-left: 4px;
            }
        }
    }

    .card-resumo-analise-duplicidade {
        background-color: var(--white);
        display: flex;
        flex-direction: column;
        border-radius: $default-border-radius;
        margin: 20px;
        padding: 20px;

        .card-resumo-analise-duplicidade__header {
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
            margin-bottom: 20px;

            h2 {
                font-weight: bold;
            }
        }

        .card-resumo-analise-duplicidade__subtitle {
            font-size: 13px;
            color: #8a8a8a;
            margin-top: 4px;
            display: block;
        }

        .card-resumo-analise-duplicidade__subsection {
            display: flex;
            justify-content: space-between;
            align-items: center;
            border: 1px dashed #d9d9d9;
            border-radius: $default-border-radius;
            padding: 15px 20px;
            margin-bottom: 15px;

            &__titulo {
                font-weight: 600;
                font-size: 14px;
            }

            &__header {
                display: flex;
                justify-content: space-between;
                align-items: center;
                width: 100%;
            }

            &--expandida {
                flex-direction: column;
                align-items: stretch;
            }
        }

        .card-resumo-analise-duplicidade__tag {
            display: inline-flex;
            align-items: center;
            padding: 2px 10px;
            border-radius: 12px;
            font-size: 12px;
            font-weight: 600;
            white-space: nowrap;

            i {
                margin-right: 5px;
                font-size: 16px;
            }

            &--sucesso {
                background-color: #ecfcf4;
                color: #3d8c73;
                border: 1px solid #3d8c73;
            }

            &--alerta {
                background-color: #fff1f0;
                color: #df675b;
                border: 1px solid #df675b;
            }

            &--atencao {
                background-color: #f6efca;
                color: #c7b239;
                border: 1px solid #d7bc25;
            }
        }

        .card-resumo-analise-duplicidade__alerta {
            display: flex;
            align-items: flex-start;
            gap: 10px;
            background-color: #fff1f0;
            border: 1px solid #fed7d6;
            border-radius: $default-border-radius;
            padding: 15px 20px;
            margin: 15px 0;

            > i {
                color: #df675b;
                font-size: 20px;
                margin-top: 2px;
            }

            strong {
                display: block;
                color: #df675b;
                margin-bottom: 4px;
            }

            p {
                font-size: 13px;
                color: #5e5e5e;
                margin: 0;
            }
        }

        .el-table__expanded-cell {
            padding: 15px 20px 15px 48px;
        }

        .card-resumo-analise-duplicidade__expand-row {
            display: flex;
            gap: 40px;
            padding: 0;

            > div {
                display: flex;
                flex-direction: column;
            }

            &__label {
                font-size: 12px;
                color: var(--primary);
                font-weight: 600;
                margin-bottom: 4px;
            }
        }

        .card-resumo-analise-duplicidade__dispensada {
            display: flex;
            flex-direction: column;
            align-items: center;
            text-align: center;
            padding: 40px 20px;

            > i {
                font-size: 32px;
                color: #c0c4cc;
                margin-bottom: 12px;
            }

            h3 {
                font-weight: bold;
                font-size: 14px;
                margin-bottom: 8px;
            }

            p {
                font-size: 13px;
                color: #8a8a8a;
                max-width: 600px;
                margin: 0;
            }
        }

        .card-resumo-analise-duplicidade__detalhes-link {
            color: var(--primary);
            cursor: pointer;
            font-size: 13px;

            i {
                margin-left: 4px;
            }
        }
    }

    .card-analise-socioambiental-operacao__acao {
        display: flex;
        justify-content: space-between;
        margin: 20px;
    }

    .card-analise-socioambiental-operacao__aprovar-recusar {
        background-color: var(--white);
        margin: 20px;
        padding: 20px;
        border-radius: $default-border-radius;

        .card-operacao-com-restricao {
            background-color: #fef9e7;
            border: 1px solid #f5d991;
            border-radius: $default-border-radius;
            padding: 15px 20px;
            margin: 15px 0;

            .card-operacao-com-restricao__header {
                display: flex;
                align-items: center;
                gap: 8px;
                margin-bottom: 8px;
            }

            .card-operacao-com-restricao__indicador {
                width: 12px;
                height: 12px;
                border-radius: 50%;
                background-color: #e8a838;
                flex-shrink: 0;
            }

            h3 {
                font-weight: bold;
                font-size: 14px;
                margin: 0;
                color: #333;
            }

            .card-operacao-com-restricao__descricao {
                font-size: 13px;
                color: #5e5e5e;
                margin: 0 0 12px 0;
            }

            .card-operacao-com-restricao__restricoes {
                strong {
                    font-size: 13px;
                    color: #333;
                    display: block;
                    margin-bottom: 4px;
                }

                ul {
                    margin: 0;
                    padding-left: 20px;
                    list-style-type: none;

                    li {
                        font-size: 13px;
                        color: #5e5e5e;
                        line-height: 1.6;
                        list-style: disc;
                    }
                }
            }
        }
    }

    .campo_obrigatorio::before {
        content: '* ';
        color: red;
    }

    .car-vinculado {
        margin-left: 55px;
    }
}

::v-deep .duplicidade-credito-table_label {
    word-break: keep-all !important;
}

.duplicidade-credito_text {
    word-break: keep-all !important;
}
</style>
